import type { DatetimeCursorPagination, PaginationWithSort } from '@repo/types/pagination';
import type { MakeRequired } from '@repo/types/utils';
import type { AxiosResponse } from 'axios';

import { HolidayCreateSchemaOutput } from '@repo/schemas/holiday/createHoliday';

import { axiosInstance } from '#api-client';

export class HolidayService {
  static async getHolidays(params?: GetHolidaysParams): Promise<AxiosResponse<Array<MakeRequired<HolidayCreateSchemaOutput, 'id'>>>> {
    return await axiosInstance.get('/api/holiday', { params: params });
  }
  static async createHoliday(payload: HolidayCreateSchemaOutput): Promise<AxiosResponse<MakeRequired<HolidayCreateSchemaOutput, 'id'>>> {
    return await axiosInstance.post('/api/holiday', payload);
  }
  static async deleteHoliday(id: number): Promise<AxiosResponse<string>> {
    return await axiosInstance.delete(`/api/holiday/${id}`);
  }
}

export interface GetHolidaysParams extends Partial<DatetimeCursorPagination>, Partial<PaginationWithSort> {
  id?: number;
}
